/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, bool, array, object, shape, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { CLIENT } from 'actions/signup';

import {
  verifyCode as verifyCodeAction,
  resetCode as resetCodeAction,
} from 'actions/user';

import StepHeader from 'components/StepHeader/StepHeader';
import Form from 'components/Form/Form';

import styles from './verify-code.scss';

/**
 * This is the VerifyCode component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class VerifyCode extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    signup: shape({
      type: string.isRequired,
    }).isRequired,
    verifyCodeForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    verifyCode: func,
    resetCode: func,
  };

  /**
   * Trigger verify code action.
   *
   * @param {Object} data
   * @param {string} data.code
   */
  verifyCode = data => {
    const {
      auth: { token },
      verifyCode,
    } = this.props;

    verifyCode(token, data);
  };

  /**
   * Trigger reset code action.
   */
  resetCode = event => {
    if (event) event.preventDefault();

    const {
      auth: { token },
      resetCode,
    } = this.props;

    resetCode(token);
  };

  /**
   * Render VerifyCode.
   *
   * @return {Object}
   */
  render() {
    const { signup, verifyCodeForm } = this.props;

    return (
      <article>
        <StepHeader
          title={p.t('signup.verify_code.title')}
          current={3}
          total={signup.type === CLIENT ? 7 : 6}
        />
        <section className={styles.content}>
          <Form {...verifyCodeForm} onSubmit={this.verifyCode} />
        </section>

        <footer className={styles.footer}>
          <p>{p.t('signup.verify_code.resend.question')}</p>

          <button className={styles.resendLink} onClick={this.resetCode}>
            {p.t('signup.verify_code.resend.link')}
          </button>
        </footer>
      </article>
    );
  }
}

export default withRouter(
  connect(
    ({ auth, signup, verifyCodeForm }) => ({ auth, signup, verifyCodeForm }),
    {
      verifyCode: verifyCodeAction,
      resetCode: resetCodeAction,
    }
  )(VerifyCode)
);
